import { HttpRestClient } from '@injectivelabs/utils';
import { Network, isDevnet, isTestnet } from '@injectivelabs/networks';
const ASSET_PRICE_SERVICE_URL = 'https://k8s.mainnet.asset.injective.network/asset-price/v1';
const TESTNET_ASSET_PRICE_SERVICE_URL = 'https://k8s.testnet.asset.injective.network/asset-price/v1';
const DEVNET_ASSET_PRICE_SERVICE_URL = 'https://devnet.asset.injective.dev/asset-price/v1';
const getAssetMicroserviceEndpoint = (network = Network.Mainnet) => {
    if (isTestnet(network)) {
        return TESTNET_ASSET_PRICE_SERVICE_URL;
    }
    if (isDevnet(network)) {
        return DEVNET_ASSET_PRICE_SERVICE_URL;
    }
    return ASSET_PRICE_SERVICE_URL;
};
export class TokenPrice {
    client;
    constructor(network) {
        this.client = new HttpRestClient(getAssetMicroserviceEndpoint(network));
    }
    async fetchUsdTokensPriceMap() {
        const response = await this.client.retry(() => this.client.get(`denoms?withPrice=true`));
        const tokenPriceMap = Object.values(response.data).reduce((prices, tokenWithPrice) => {
            const id = tokenWithPrice.coingecko_id || tokenWithPrice.denom;
            if (prices[id]) {
                return prices;
            }
            prices[id] = tokenWithPrice.price.price;
            return prices;
        }, {});
        return tokenPriceMap;
    }
}
